import ErrorBoundariesPage from "./ErrorBoundariesPage"
import { ErrorBoundaryRapper } from "./ErrorBoundaryRapper"

const ErrorBoundary = (
    {
        children
    }:{
        children: React.ReactNode
    }
) => {
    return(
        <ErrorBoundaryRapper fallback={(error) => <ErrorBoundariesPage error={error} />}>
            {children}
        </ErrorBoundaryRapper>
    )
}

export default ErrorBoundary;